"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionService = void 0;
class SessionService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Refresh Token
     * @returns TokenRefreshResponseModel Successful Response
     * @throws ApiError
     */
    chathostRefreshToken() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/session/refresh/token',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Logoff
     * @returns LogoffResponseModel Successful Response
     * @throws ApiError
     */
    chathostLogoff() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/session/logoff',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Refresh Token
     * @returns TokenRefreshResponseModel Successful Response
     * @throws ApiError
     */
    studioRefreshToken() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/session/refresh/token',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Logoff
     * @returns LogoffResponseModel Successful Response
     * @throws ApiError
     */
    studioLogoff() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/session/logoff',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
}
exports.SessionService = SessionService;
